import { render, staticRenderFns } from "./LaudoBenfeitorias.vue?vue&type=template&id=a925dbd6&scoped=true&lang=pug"
import script from "./LaudoBenfeitorias.vue?vue&type=script&lang=js"
export * from "./LaudoBenfeitorias.vue?vue&type=script&lang=js"
import style0 from "./LaudoBenfeitorias.vue?vue&type=style&index=0&id=a925dbd6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a925dbd6",
  null
  
)

export default component.exports